import React, { useEffect, useState } from "react";
import { selfserviceCredit_card } from "../../redux/actions";

const CreditInfo = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceCredit_card();
        setOrders(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOrders();
  }, []);

  return (
    <section className="hot-deals pt-10">
      <div className="container container-lg ">
        <div className="row gy-4">
          <div className="col-sm-6 ">
            <div className="position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                <h3 className="text-blue mb-8">Credit Information</h3>
              </div>
              <div>
                <div className="flex-align gap-8 d-flex justify-content-between w-50 p-2">
                  <span className="text-sm text-white">
                    <p className="text-black">Authorized Credit Limit</p>
                  </span>
                  <span className="text-sm text-main-two-600">
                    <p className="text-black">
                      {orders?.page?.data?.company_credit_details?.credit_limit}
                    </p>
                  </span>
                </div>
                <hr></hr>
                <div className="flex-align gap-8 d-flex justify-content-between w-50 p-2">
                  <span className="text-sm text-white">
                    <p className="text-black">Current Credit Usage</p>
                  </span>
                  <span className="text-sm text-main-two-600">
                    <p className="text-black">
                      {orders?.page?.data?.company_credit_details?.credit_used}
                    </p>
                  </span>
                </div>
                <hr></hr>
                <div className="flex-align gap-8 d-flex justify-content-between w-50 p-2">
                  <span className="text-sm text-white">
                    <p className="text-black">Remaining Credit</p>
                  </span>
                  <span className="text-sm text-main-two-600">
                    <p className="text-black">
                      {
                        orders?.page?.data?.company_credit_details
                          ?.credit_balance
                      }
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* grid for componants */}
          {/* <div className="col-sm-6 ">
            <div className="position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-4">
                <h3 className="text-blue ack mb-8">Apply For Credit</h3>

                <div className="center col-xxl-3 col-lg-12 col-sm-6">
                  <button
                    className="le btn btn-main d-inline-flex align-items-center gap-8 mt-24"
                    type="button"
                  >
                    Open Credit Form{" "}
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <br></br>
        <br></br>
      </div>
    </section>
  );
};

export default CreditInfo;
